var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarningTriangle(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M327.7,66.9l171.6,285.7c24.7,41,12.5,95-27.1,120.6c-13.3,8.6-28.8,13.2-44.6,13.2H84.4C37.8,486.4,0,447.2,0,398.9 c0-16.4,4.4-32.4,12.8-46.3L184.3,66.9c24.6-41,76.7-53.6,116.3-28.1C311.6,45.9,320.8,55.5,327.7,66.9z M256,384 c14.1,0,25.6-11.5,25.6-25.6c0-14.2-11.5-25.6-25.6-25.6c-14.1,0-25.6,11.5-25.6,25.6C230.4,372.5,241.9,384,256,384z M256,153.6 c-14.1,0-25.6,11.5-25.6,25.6v102.4c0,14.1,11.5,25.6,25.6,25.6c14.1,0,25.6-11.5,25.6-25.6V179.2 C281.6,165.1,270.1,153.6,256,153.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarningTriangle);
export default __webpack_public_path__ + "static/media/icon-warning-triangle.acc47515effe5def156e7c88b85a070b.svg";
export { ForwardRef as ReactComponent };